import { Injectable } from '@angular/core';
import { Endpoint } from '@shared/models/app-config.interface';
import { AppSettings } from '@shared/models/app-settings.inteface';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private _appConfigs!: Endpoint;
  private _appSettings!: AppSettings;

  getAppConfigs(): Endpoint {
    return this._appConfigs;
  }

  setAppConfigs(config: any) {
    this._appConfigs =  JSON.parse(config.toString()).APIs as Endpoint;
  }

  getAppSettings(): AppSettings {
    return this._appSettings;
  }

  setAppSettings(config: any) {
    this._appSettings = JSON.parse(config.toString()) as AppSettings;
  }
}
